import * as React from 'react';
import { Modal } from 'antd';
import closeBtn from '@images/icon/btn_close_p.png';

export type MessageProps = {
  visible?: boolean;
  messageText?: string | React.ReactNode;
  onCancel?: ((e: React.MouseEvent<HTMLElement, MouseEvent>) => void) | undefined;
  width?: number;
};

const ModalMessage = ({ visible, messageText, onCancel, width }: MessageProps) => {
  // 모달 닫기버튼
  const modalClosed = <img src={closeBtn} alt="팝업닫기" />;

  return (
    <Modal visible={visible} centered closeIcon={modalClosed} onCancel={onCancel} footer={null} width={width} className="pincarbiz message-modal">
      <div className="message-text">{messageText}</div>
    </Modal>
  );
};

ModalMessage.defaultProps = {
  visible: false,
  messageText: '메시지창',
  width: 260,
};

export default ModalMessage;
